// extracted by mini-css-extract-plugin
export default {"componentWrapper":"ChangePasswordForm_componentWrapper__Apm05","formElement":"ChangePasswordForm_formElement__F9bbb","actions":"ChangePasswordForm_actions__zl-o7"};